const getUser = () => {
    let userItem = localStorage?.getItem("user") ?? null;
    let userLocal = userItem != null && userItem !== "undefined" ? JSON.parse(userItem) : null;
    return userLocal;
}
export {
    getUser
}